import { Button } from '@change/ds-core-ui/Button';
import { Text } from '@change/ds-core-ui/Text';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { ErrorHandlerProps } from '#src/app/pages/socialStarter/socialStarterDraft/pageContext';
import { useTrackView } from '#src/app/shared/hooks/tracking';

export const SocialStarterErrorHandler: React.FC<ErrorHandlerProps> = () => {
	const { translate } = useI18n();
	useTrackView('sap_social_view', { status: 'error' });

	return (
		<div className="container mx-auto flex max-w-[620px] flex-col items-center gap-6 px-5 py-16 text-center">
			<Text as="h1" variant="heading">
				{translate('corgi.social_starter_shared.error.not_found.heading')}
			</Text>
			<Text as="p" variant="body" size="large">
				{translate('corgi.social_starter_shared.error.not_found.description')}
			</Text>
			<Button as="a" href="/" variant="primary" size="large">
				{translate('corgi.social_starter_shared.error.not_found.cta')}
			</Button>
		</div>
	);
};
